import auth from './auth'
import contact from './forms/contact'
import info from './forms/application'

const stores = {
  AuthStore: auth,
  ContactStore: contact,
  InfoStore: info,
}
export default stores
